import { CircularProgress, Stack, useTheme } from "@mui/material";
import React, { FunctionComponent } from "react";
import styles from "./styles.module.scss";
import { strings } from "../../localization/LocalizedStrings";
import { ContainedButton } from "../ContainedButton";
import { IOngoingTask } from "../../models/OngoingTask";

export const ImportProgressView: FunctionComponent<IImportProgressViewProps> = ({
  task,
  subtitle,
  runningDescription,
  disclaimer,
  isLoading,
  onCancel
}) => {
  const theme = useTheme();
  const progressBarColor = () => {
    switch (task?.status) {
      case "created":
      case "running":
        return theme.palette.colors.progressRunning;
      case "finished":
        return theme.palette.colors.progressSuccess;
      case "cancelled":
      case "errored":
        return theme.palette.colors.progressError;
    }
  };
  return (
    <Stack spacing={4} alignItems={"center"} display={"flex"} style={{ height: "100%" }}>
      <p className={styles.subtitle}>{subtitle}</p>
      {task.status === "running" && <p className={styles.message}>{runningDescription}</p>}
      <p className={styles.message}>{disclaimer}</p>
      <div className={styles.progressBar}>
        <div
          className={styles.progressBarDiv}
          style={{
            color: theme.palette.background.default
          }}
        >
          <CircularProgress color={"inherit"} size={150} variant={"determinate"} value={100} />
        </div>
        <div
          className={styles.progressBarDiv}
          style={{ display: "flex", position: "absolute", color: progressBarColor() }}
        >
          <CircularProgress
            color={"inherit"}
            size={150}
            variant={task.status == "created" ? "indeterminate" : "determinate"}
            value={(task.progress * 100) / task.objective}
          />
        </div>
        <p className={styles.progressText} style={{ color: theme.palette.primary.main }}>
          {task.status == "created" ? "" : task.progress}
        </p>
      </div>
      {["created", "running"].includes(task.status) && (
        <ContainedButton className={styles.cancelButton} disabled={isLoading} onClick={onCancel}>
          {strings.cancel_import}
        </ContainedButton>
      )}
    </Stack>
  );
};

export interface IImportProgressViewProps {
  task: IOngoingTask;
  subtitle: string;
  runningDescription: string;
  disclaimer: string;
  isLoading: boolean;
  onCancel: () => void;
}
